import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { searchEnterprisesAndBrands } from 'apis/enterprise/api';

export const useEnterpriseBrandSearch = (searchString: string, isEnabled: boolean) => {
  const {
    isError: hasError,
    isFetching: isSearching,
    data: searchEnterprisesBrandsResults,
  } = useQuery(
    [`/v1/search?q=${searchString}`],
    () => {
      return searchEnterprisesAndBrands(searchString);
    },
    {
      enabled: isEnabled,
    },
  );

  const matchingEnterprises = useMemo(() => {
    return searchEnterprisesBrandsResults ? searchEnterprisesBrandsResults.enterprises.map(result => result.value) : [];
  }, [searchEnterprisesBrandsResults]);

  const matchingBrands = useMemo(() => {
    return searchEnterprisesBrandsResults ? searchEnterprisesBrandsResults.brands.map(result => result.value) : [];
  }, [searchEnterprisesBrandsResults]);

  return {
    data: {
      brands: matchingBrands,
      enterprises: matchingEnterprises,
    },
    isSearching,
    hasError,
  };
};
